import { useEffect, useState } from "react"
import { ChevronRight } from "lucide-react"

// How long the close transition runs before the panel unmounts — must match
// shared-layout.css' .sidebar transition-duration (250ms).
const SIDEBAR_EXIT_MS = 250

export function SidebarComponent(input: {
  children: React.ReactNode
  onClose: ()=> void
  visible: boolean
}) {
  // Keep the panel mounted through its close transition: `rendered` tracks
  // DOM presence, `closing` applies the exit pose. The old
  // `if (!visible) return null` made closing a teleport with no exit, and
  // opening was a one-shot keyframe that restarted from zero.
  const [rendered, setRendered] = useState(input.visible)
  const [closing, setClosing] = useState(false)

  useEffect(()=> {
    if (input.visible) {
      setClosing(false)
      setRendered(true)
      return
    }
    if (!rendered) return
    setClosing(true)
    const timer = setTimeout(()=> {
      setRendered(false)
      setClosing(false)
    }, SIDEBAR_EXIT_MS)
    return ()=> {
      clearTimeout(timer)
    }
  }, [input.visible, rendered])

  if (!rendered) {
    return null
  }
  return (
    <div className={`sidebar${closing ? " sidebar--closing" : ""}`}>
      <div className="sidebar__panel">{input.children}</div>
      <button
        aria-label="Close sidebar"
        className="sidebar__dismiss"
        onClick={input.onClose}
        type="button"
      >
        <ChevronRight size={24} />
      </button>
    </div>
  )
}
